import { ChartDataStatus } from "../model/chart-data-status.type";

export function geDataStatus(newData: any[] | null | undefined, oldData: any[] | null | undefined, idKey: string): ChartDataStatus {
  if (newData === undefined || newData === null) {
    return 'IS_UNSET';
  } else if (oldData === null || oldData === undefined) {
    return 'IS_FIRST_SET'
  } else if (newData.length && oldData.length && newData.length === oldData.length && !newData.every(newItem => oldData.find(oldItem => newItem[idKey] === oldItem[idKey]))) {
    return 'SAME_LENGTH_DIFFERENT_ITEMS'
  } else if (newData.length && oldData.length && newData.length === oldData.length) {
    return 'SAME_LENGTH_SAME_ITEMS'
  } else if (newData.length > oldData.length) {
    return 'MORE_LENGTH'
  } else if (newData.length < oldData.length) {
    return 'LESS_LENGTH'
  } else {
    return 'UNKNOWN'
  }
}